import React, { useCallback, useState, useEffect } from 'react';
import { Button, Col, Modal, Row } from 'antd';

import NPSIcon from 'assets/images/NPS.svg';

import { useTranslation } from 'react-i18next';

const ModalNPSNotification = () => {
  const { t: translate } = useTranslation();

  const [visible, setVisible] = useState(false);

  const closeModal = useCallback(() => {
    setVisible(false);
  }, []);

  useEffect(() => {
    const today = new Date();
    const dayOfMonth = today.getDate();
    const monthOfYear = today.getMonth();
    const fullYear = today.getFullYear();

    const hasShownToday = localStorage.getItem(`modalShown_${dayOfMonth}`);
    const isMonthAndYear = monthOfYear === 11 && fullYear === 2023; // dezembro de 2023
    const daysToShow = [11, 13, 15, 17, 19, 21];

    // verifica pelo localStorage se o modal já foi mostrado hoje, se está no grupo de usuários correto e se é um dos dias da semana/ano/mes que o modal deve ser mostrado
    if (!hasShownToday && daysToShow.includes(dayOfMonth) && isMonthAndYear) {
      setVisible(true);
      localStorage.setItem(`modalShown_${dayOfMonth}`, 'true');
    }
  }, []);

  return (
    <Modal visible={visible} width={680} onCancel={closeModal} footer={null} centered>
      <Row justify="center" align="middle" className="mrg-vertical-20">
        <Col>
          <img src={NPSIcon} alt="" />
        </Col>
      </Row>
      <Row justify="center" className="mrg-vertical-20">
        <Col>
          <span className="text-bold h1">
            {translate('pages.private.NPSModal.title')}
          </span>
        </Col>
      </Row>
      <Row justify="center" style={{ width: 480, textAlign: 'center', margin: 'auto' }}>
        <Col span={24}>
          <span className="mrg-top-20 h5">
            {translate('pages.private.NPSModal.description')}
          </span>
        </Col>
      </Row>
      <Row justify="center" style={{ width: 480, textAlign: 'center', margin: 'auto' }}>
        <Col span={24}>
          <p className="mrg-top-20 h5">
            {translate('pages.private.NPSModal.description.footer')}
          </p>
        </Col>
      </Row>
      <Row
        className="mrg-top-20 text-bold"
        justify="center"
        style={{
          width: 480,
          textAlign: 'center',
          marginLeft: 'auto',
          marginRight: 'auto',
          marginBottom: 64,
        }}
      >
        <Col span={24} style={{ maxWidth: 580, margin: 'auto' }}>
          <Button
            type="primary"
            onClick={() => {
              window.open(
                'https://cafio.my.site.com/nps/survey/runtimeApp.app?invitationId=0KiU50000005OWL&surveyName=nps_caf_2023_2&UUID=9d02c460-e336-409d-b60a-33b68d8e655d',
                '_blank'
              );
              closeModal();
            }}
          >
            {translate('pages.private.NPSModal.buton')}
          </Button>
        </Col>
      </Row>
    </Modal>
  );
};

export default ModalNPSNotification;
